
































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";

@Component
export default class ActivateStamp extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) mainSerialNo: string;
  @Prop({ type: String, default: "" }) sku: string;
  @Prop({ type: String, default: "" }) productName: string;

  spinShow: boolean = false;
  reasonId = "0";
  reasonOther = "";
  reasons = [];
  namespace = "collectionCodeProduct";

  visibleChange(value: boolean) {
    if (!value) {
      this.reset();
      this.$emit("input", value);
    } else {
      this.getReasons();
    }
  }
  async mounted() {}
  created() {
    this.getReasons();
  }
  reset() {
    this.reasonId = "0";
    this.reasonOther = "";
    this.reasons = [];
  }
  async getReasons() {
    this.$store
      .dispatch({
        type: `${this.namespace}/getStampActivateReasons`,
      })
      .then((result) => {
        var re = result;
        re.push({ code: "0", description: this.L("Other") });
        this.reasons = re;
      });
  }
  save() {
    if (_.isNil(this.reasonId) || +this.reasonId < 0) {
      Util.showNoticeErrorMsg(
        this,
        Util.L(
          "Error.RequiredField0",
          undefined,
          this.L("StampActivateReasons")
        )
      );
      return;
    }
    if (
      +this.reasonId === 0 &&
      (_.isNil(this.reasonOther) || _.isEmpty(this.reasonOther))
    ) {
      Util.showNoticeErrorMsg(
        this,
        Util.L(
          "Error.RequiredField0",
          undefined,
          this.L("StampActivateReasons")
        )
      );
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.ActivateStamp"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: () => {
        this.spinShow = true;

        this.$store
          .dispatch({
            type: `${this.namespace}/stampActivate`,
            data: {
              mainSerialNo: this.mainSerialNo,
              reasonId: +this.reasonId,
              reasonOther: +this.reasonId > 0 ? null : this.reasonOther,
            },
          })
          .then(() => {
            Util.showSuccessMsgCallback(
              this,
              "Success.ActivateStamp",
              this.saveSuccessCallback
            );
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  saveSuccessCallback() {
    (this.$refs.activateStampForm as any).resetFields();
    this.$emit("save-success");
    this.$emit("input", false);
  }
  cancel() {
    this.reset();
    (this.$refs.activateStampForm as any).resetFields();
    this.$emit("input", false);
  }
}
